import * as React from 'react';
import * as workout from './style.module.scss';
import * as main from "../../../styles/main.module.scss";
export const WorkoutYoung = ({ btnText="Записаться на пробные уроки" }) => {
  return (
    <section className={workout.workout}>
      <div className={`container ${workout.workout__container}`}>
        <h3 className={workout.workout__title}>
          Регулярные тренировки — доступный способ развития и поддержания когнитивных навыков
        </h3>
        <div className={workout.workout__description}>
          <p>
            Если не тренировать когнитивные навыки, то они будут слабеть с каждым годом. В результате — плохая память, рассеянность, неспособность держать в голове важные детали.
          </p>
          <p>
            Недостаток когнитивных навыков существенно снижает качество жизни. Приходится писать списки, ставить напоминания и периодически оправдываться за свою рассеянность перед родными и коллегами.
          </p>
          <p>
            Но это совсем не обязательный сценарий!
            <span>
                <strong> Прямо сейчас вы можете сделать важный шаг на пути к улучшению памяти и внимания.</strong>
            </span>
          </p>
        </div>
        <a href="#cost" className={`${main.mainBtnRound} ${workout.workout__btn}`}>
          { btnText }
        </a>
        <img
          src="https://fs.advance.ru/landing-pages/course/kurs-razvitiya-pamyaty/photo-young-krp-03.png"
          alt=""
          className={workout.workout__img}
        />
      </div>
    </section>
  );
};
